import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-row-reverse" }
const _hoisted_2 = {
  key: 1,
  class: "pending-label"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "mb-24 d-flex justify-content-center align-items-center" }
const _hoisted_5 = { class: "period" }
const _hoisted_6 = { class: "period" }
const _hoisted_7 = { class: "info-box" }
const _hoisted_8 = { class: "row-info d-flex justify-content-between" }
const _hoisted_9 = { class: "row-info d-flex justify-content-between" }
const _hoisted_10 = { class: "row-info d-flex justify-content-between" }
const _hoisted_11 = { class: "row-info d-flex justify-content-between" }
const _hoisted_12 = { class: "row-info d-flex justify-content-between" }
const _hoisted_13 = { class: "row-info d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoneSvg = _resolveComponent("DoneSvg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'quadrant': true,
      'quadrant-completed': _ctx.quadrant.is_completed,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.quadrant.is_completed)
        ? (_openBlock(), _createBlock(_component_DoneSvg, {
            key: 0,
            class: "done-svg"
          }))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, "Pending"))
    ]),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.periodFrom), 1),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "period-separator" }, null, -1)),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.periodTo), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "new-partners-label" }, "New Partners", -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.new_partners), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "macd-label" }, "MACD", -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.add + _ctx.quadrant.macd.move + _ctx.quadrant.macd.change + _ctx.quadrant.macd.disconnect), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "dot dot-moved" }, " "),
          _createElementVNode("div", null, "Moved")
        ], -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.move), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "dot dot-add" }, " "),
          _createElementVNode("div", null, "Add")
        ], -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.add), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "dot dot-change" }, " "),
          _createElementVNode("div", null, "Change")
        ], -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.change), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
          _createElementVNode("div", { class: "dot dot-disconnect" }, " "),
          _createElementVNode("div", null, "Disconnect")
        ], -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.disconnect), 1)
      ])
    ])
  ], 2))
}